import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-63d32139"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_titleBox = _resolveComponent("titleBox");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_titleBox, null, {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "title", {}, undefined, true)]),
    _: 3
  }), _createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "body", {}, undefined, true)])], 64);
}